
export const formFields = {
    ionAccountID: {
        key: 'ionAccountID',
        label: 'Account ID',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        maxLength: 100,
        maxLengthMessage: 'maximum 100 characters allowed.',
        displayLayout: 'col-md-7',
        tooltip: '<div> Account ID </div>',
        pattern: /^\d{0,100}$/
    },
    ionCurrency: {
        key: 'ionCurrency',
        label: 'Currency',
        placeholder: '',
        type: "text",
        displayLayout: 'col-md-7',
        valueKey: 'key',
        required: true,
        requiredMessage: 'This field  is required.',
        textKey: 'value',
        tooltip: '<div>  Currency </div>',
        pattern: /^[A-Z]*$/
    },
}
export const ionAdsFields = {
  ionMasterAccountID: {
      key: 'ionMasterAccountID',
      type: 'text',
      label: 'Tenant Token',
      placeholder: 'Enter Tenant Token',
      required: true,
      requiredMessage: 'This field is required.',
      // maxLength: 50,
      // maxLengthMessage: 'maximum 100 characters allowed.',
      displayLayout: 'col-md-12',
      labelLayout: 'col-md-12',
      tooltip: '<div> Tenant Token</div>',
      // pattern: /^\d{0,100}$/
    },
    ionAdvertiserID: {
      key: 'ionAdvertiserID',
      type: 'text',
      label: 'Advertiser ID',
      placeholder: '',
      required: true,
      requiredMessage: 'This field is required.',
      maxLength: 100,
      maxLengthMessage: 'maximum 100 characters allowed.',
      displayLayout: 'col-md-12',
      labelLayout: 'col-md-12',
      tooltip: '<div> Advertiser ID </div>',
      pattern: /^\d{0,100}$/
    },
  
    ionCurrency: {
      key: 'ionCurrency',
      label: 'Currency',
      placeholder: '',
      type: "text",
      displayLayout: 'col-md-12',
      labelLayout: 'col-md-12',
      valueKey: 'key',
      required: true,
      requiredMessage: 'This field  is required.',
      textKey: 'value',
      tooltip: '<div>  Currency </div>',
      pattern: /^[A-Z]*$/
    }
  }